/*
  Het pakje openen. Werkt op elk podium met data-cf-pack-kaarten, en op meerdere
  podia tegelijk: op de productpagina staat het pakje naast de chase cards, op de
  pre-orderpagina onder de lijst.

  De kaarten komen als JSON uit het data-attribuut, dat Liquid vult uit
  kaarten_json op de kaartenset. Geen kaarten of kapotte JSON: dan doet de knop
  niets en blijft het pakje gewoon staan.
*/
(function () {
  'use strict';

  function start(podium) {
    var kaarten;
    try { kaarten = JSON.parse(podium.dataset.cfPackKaarten); }
    catch (e) { return; }
    if (!kaarten || !kaarten.length) return;

    var pack  = podium.querySelector('[data-cf-pack]');
    var trek  = podium.querySelector('[data-cf-trek]');
    var flits = podium.querySelector('[data-cf-flits]');
    if (!pack || !trek) return;

    var vorige = -1;

    function kies() {
      var i;
      do { i = Math.floor(Math.random() * kaarten.length); }
      while (kaarten.length > 1 && i === vorige);
      vorige = i;
      return kaarten[i];
    }

    function tekst(el, waarde) {
      el.textContent = waarde == null ? '' : String(waarde);
    }

    function openen() {
      pack.classList.add('is-open');
      setTimeout(function () {
        pack.classList.remove('is-open');
        pack.classList.add('is-weg');
        if (flits) {
          flits.classList.add('is-aan');
          setTimeout(function () { flits.classList.remove('is-aan'); }, 640);
        }

        var k = kies();

        /* Met de DOM opgebouwd en niet met innerHTML: de kaartnamen komen uit een
           metaobject dat iemand handmatig vult, en die hoort hier nooit als html
           uitgevoerd te worden. */
        var kaart = document.createElement('span');
        kaart.className = 'cf-holokaart';
        kaart.setAttribute('data-cf-holo', '');

        var img = document.createElement('img');
        img.src = k.img + '&width=420';
        img.alt = k.naam || '';

        var glans = document.createElement('span'); glans.className = 'cf-glans';
        var holo  = document.createElement('span'); holo.className  = 'cf-holo';
        kaart.appendChild(img);
        kaart.appendChild(glans);
        kaart.appendChild(holo);

        var naam = document.createElement('div');
        naam.className = 'cf-trek-naam';
        var p1 = document.createElement('p');
        tekst(p1, '#' + (k.nr || '') + ' ' + (k.naam || ''));
        naam.appendChild(p1);

        /* Niet elke kaart heeft een zeldzaamheid, de Mew-promo's bijvoorbeeld niet.
           Dan helemaal geen regel, want een lege regel leest als een fout. */
        if (k.rar) {
          var p2 = document.createElement('span');
          tekst(p2, k.rar);
          naam.appendChild(p2);
        }

        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'cf-nogmaals';
        var taal = (window.CardifyI18n && window.CardifyI18n.taal) || 'nl';
        tekst(knop, taal === 'en' ? 'Another pack' : 'Nog een pakje');
        knop.addEventListener('click', sluiten);

        trek.innerHTML = '';
        trek.appendChild(kaart);
        trek.appendChild(naam);
        trek.appendChild(knop);
        trek.classList.add('is-zichtbaar');
      }, 340);
    }

    function sluiten() {
      trek.classList.remove('is-zichtbaar');
      trek.innerHTML = '';
      pack.classList.remove('is-weg');
      setTimeout(openen, 240);
    }

    pack.addEventListener('click', openen);
  }

  var podia = document.querySelectorAll('[data-cf-pack-kaarten]');
  for (var i = 0; i < podia.length; i++) start(podia[i]);
})();
